<div class="op-plaid-disclosure" *transloco="let t">
	<div *ngIf="subjectToEvaluation" class="op-micro-font op-dark-grey">
		<p [innerHTML]="t('PLAID_CONNECT.subjectToEvaluation')"></p>
		<p [innerHTML]="t('PLAID_CONNECT.neverStore')"></p>
	</div>
	<div *ngIf="!subjectToEvaluation" class="op-micro-font op-dark-grey">
		<span [innerHTML]="t('PLAID_CONNECT.bankTransactionInfo')"></span>
		<span>&nbsp;</span>
		<span *ngIf="byClicking" [innerHTML]="t('PLAID_CONNECT.neverStore')"></span>
		<span *ngIf="!byClicking" [innerHTML]="t('PLAID_CONNECT.neverStoreLogin')"></span>
	</div>
</div>
